import PersonalPage from './PersonalPage';

export default PersonalPage;
